import Tag from "./tag.container";

export default Tag;
